import { FC } from "react";

import { Box } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

import Icon from "@components/Icon";
import Message from "@components/Message";
import responsiveStyle from "@lib/theme/responsiveStyle";

const SuccessMessage: FC = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Message
        variant="success"
        icon={<Icon icon="success" size="2.25rem" />}
        padding={responsiveStyle({ mobile: "1rem 1rem", desktop: "1.75rem 1.25rem" })}
      >
        <Box fontSize={responsiveStyle({ mobile: "1.125rem", desktop: "1.5rem" })}>
          {t("order-success-parcel_prepared")}
        </Box>
      </Message>
    </Box>
  );
};
export default SuccessMessage;
